<template>
  <main class="mainError">
    <h1 class="display-5">Error 404</h1>
    <button
      type="button"
      class="btn btn-outline-primary"
      @click="$router.go(-2)"
    >
      back
    </button>

    <hr class="" />
    <h2>Seite nicht gefunden {{ $route.params.error }}</h2>
  </main>
</template>

<script>
export default {
  name: "NotFound",
  metaInfo: {
    title: "NotFound",
    titleTemplate: "%s | NEW ABC APP",
  },

  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {},
};
</script>
